var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"homeTitWrap"},[_c('div',{staticClass:"homeTit"},[_c('span',{staticClass:"tit"},[_vm._v(_vm._s(_vm.title))]),(_vm.isMore)?_c('span',{staticClass:"more",on:{"click":_vm.goOther}},[_vm._v("更多 >")]):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }